<template>
  <div class="panel">
    <div class="noticebox">
      <div class="container" style="background: #80b5ef40">
        <i class="fa fa-bell-o" style="background: #006adf"></i>
        <p class="notice-p">
          群盘功能升级了！新增了角色与权限管理功能哦！<a :href="msgUrl"
            >点击这里查看帮助文档。</a
          >
        </p>
      </div>
    </div>
    <div class="panel-body" style="padding-top: 0">
      <div class="mychilidTab-box clearfix">
        <ul class="nav nav-tabs child-tabs" id="mychlidTab">
          <li
            v-for="list in tabs"
            :key="list.id"
            :class="{ active: list.href === tab }"
            @click="switchTabByClick(list)"
            v-show="
              list.display &&
              (list.id !== 8 ||
                (list.id === 8 && group.group_is_open_publish && showPublish))
            "
          >
            <a :href="'#' + list.href" data-toggle="tab">{{ list.name }}</a>
          </li>
        </ul>
        <div class="button-container" style="display: block">
          <div
            @click="handleCreateSend('send')"
            class="dropdown"
            v-if="
              right__link && (tab === 'groupdisk-send' &&
              group &&
              hasCreatePublishSharePermission)
            "
          >
            <div class="dropdown-toggle">
              <i class="iconfont icon-newgroup"></i>
              新建
            </div>
          </div>
          <div
            @click="handleSearchGroupFileFilter"
            class="dropdown"
            v-if="tab === 'groupdisk-file'"
          >
            <div class="dropdown-toggle">
              <i class="ti-filter"></i>
              搜索
            </div>
          </div>
          <SearchGroupFileFilter
            :searchType="searchType"
            :group_number="group_number"
            @toggleSearch="toggleSearch"
            v-if="tab === 'groupdisk-file'"
          ></SearchGroupFileFilter>
          <!-- <NewFolder
            :isShowNewFolder="isShowUpload"
            @createNewFolder="createNewFolder"
          ></NewFolder>
          <Upload :isShowUpload="isShowUpload"></Upload> -->
          <Tag
            v-if="hasPreviewResourceTagPermission"
            :isShowTag="isShowTag"
            @filterByTag="filterByTag"
          ></Tag>
          <List
            :isShowList="isShowList"
            :isList="isList"
            @showList="showList"
          ></List>
        </div>
      </div>
      <div class="filepath">
        <a
          @click="getInfoByFatherId('up')"
          :class="{ 'no-click': noClick }"
          v-show="'groupdisk-file' === tab"
          >返回上一级</a
        >
        <a
          @click="getShareResourceList('up')"
          :class="{ 'no-click': noClick }"
          v-show="tab === 'groupdisk-share'"
          >返回上一级</a
        >
        <a
          @click="getLinkResourceList('up')"
          :class="{ 'no-click': noClick }"
          v-show="tab === 'groupdisk-send'"
          >返回上一级</a
        >
        <span class="line">|</span>
        <a @click="getAllInfo">{{ bread }}</a>
        <span
          v-for="(lel, index) in level"
          :key="index"
          v-if="'groupdisk-file' === tab"
        >
          <i class="ti-angle-right"></i>
          <a @click="getInfoByFatherId(lel)">{{ lel.name }}</a>
        </span>
        <span
          v-for="(lel, index1) in level"
          :key="index1"
          v-if="tab === 'groupdisk-share'"
        >
          <i class="ti-angle-right"></i>
          <a @click="getShareResourceList(lel)">{{
            index1 === 0 ? lel.share_title : lel.name
          }}</a>
        </span>
        <span
          v-for="(lel, index2) in level"
          :key="index2"
          v-if="tab === 'groupdisk-send'"
        >
          <i class="ti-angle-right"></i>
          <a @click="getLinkResourceList(lel)">{{
            index2 === 0 ? lel.link_title : lel.name
          }}</a>
        </span>
        <span
          class="add-resource-btn"
          v-if="
            tab === 'groupdisk-send' &&
            level.length === 1 &&
            group &&
            hasEditPublishPermission
          "
          @click="handleEditSend('send_edit_resource')"
        >
          <i class="iconfont icon-send"></i>修改发布的资源
        </span>
      </div>
      <keep-alive>
        <component
          :is="table"
          :isList="isList"
          :isCreateProcessing="isCreateProcessing"
          @getInfoByFatherId="getInfoByFatherId"
          @getShareResourceList="getShareResourceList"
          @getLinkResourceList="getLinkResourceList"
          @saveNewFolder="saveNewFolder"
          @createNewFolder="createNewFolder"
          @updateCreateProcessing="updateCreateProcessing"
        ></component>
      </keep-alive>
    </div>
    <TableSend v-if="status.TableSendStatus" @refresh="refresh"></TableSend>
    <TableSendEdit
      v-if="status.TableSendEditStatus"
      @refresh="refresh"
    ></TableSendEdit>
    <TableSendEditResource
      v-if="status.TableSendEditResourceStatus"
      @refresh="refreshResource"
    ></TableSendEditResource>
  </div>
</template>

<script>
import { getRolePermissions } from "@/utils/permission";
import { shareTargetInfo, linkInfo } from "@/api/share/share";
import { fileOrFolderInfo } from "@/api/drive/drive";
export default {
  name: "GroupDisk",
  components: {
    NewFolder: () => import("@/views/Common/NewFolder"),
    Upload: () => import("@/views/Common/Upload"),
    SearchGroupFileFilter: () => import("@/views/Search/SearchGroupFileFilter"),
    List: () => import("@/views/Common/List"),
    Tag: () => import("@/views/Common/Tag"),
    Table: () => import("@/components/Table/Table"),
    TableShareResource: () => import("@/components/Table/TableShareResource"),
    TableSend: () => import("@/components/Table/TableOperate/TableSend"),
    TableSendEdit: () =>
      import("@/components/Table/TableOperate/TableSendEdit"),
    TableSendEditResource: () =>
      import("@/components/Table/TableOperate/TableSendEditResource"),
  },
  data() {
    return {
      isCreateProcessing: false,
      msgUrl: process.env.VUE_APP_MSG_URL,
      searchType: "file",
      status: {
        TableSendStatus: false,
        TableSendEditStatus: false,
        TableSendEditResourceStatus: false,
      },
      file: {},
      bread: "全部",
      level: [],
      isShowUpload: false,
      isShowList: false,
      isShowTag: false,
      searchTab: {
        "groupdisk-file": 0,
        "groupdisk-share": 1,
        "groupdisk-send": 2,
      },
      tabs: [
        {
          id: 6,
          table: "Table",
          name: "文件",
          bread: "全部",
          href: "groupdisk-file",
          isShowUpload: true,
          isShowList: true,
          isShowTag: true,
          drive: "groupdisk",
          query: {
            disk_type: "cloud",
            category: "all",
            group_number: null,
          }, //query待修改
          display: true,
        },
        {
          id: 7,
          table: "Table",
          name: "分享到群",
          bread: "全部",
          href: "groupdisk-share",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          drive: "groupdisk",
          query: {
            disk_type: "cloud",
            category: "all",
          }, //query待修改
          display: false,
        },
        {
          id: 8,
          table: "Table",
          name: "已发布",
          bread: "全部",
          href: "groupdisk-send",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          drive: "groupdisk",
          query: {
            disk_type: "cloud",
            category: "all",
          }, //query待修改
          display: false,
        },
      ],
      temp: {
        name: "新建文件夹",
        type: "folder",
        size: "--",
        shareAt: "--",
        createAt: "--",
        last_update_date: "--",
        creater_user_real_name: "--",
        shareFormUser: "--",
        shareToUser: "--",
        shareTimes: 0,
        isStar: false,
        disk_type: "cloud",
        isEdit: true,
        isCreate: true,
        isSelected: false,
        parent_number: null,
        parent_path_number: null,
      },
    };
  },
  created() {
    this.group_number = this.$route.params.groupNumber;
    let type = this.$route.query.type;
    if (type) {
      switch (type) {
        case "file":
          this.jumpToGroupdrive("groupdisk-file");
          if (this.$route.query.number) {
            this.file = {
              number: this.$route.query.number,
            };
            this.getGroupFileInfoForSearch();
          }
          break;
        case "share":
          this.jumpToGroupdrive("groupdisk-share");
          if (this.$route.query.share) {
            this.file = {
              share_number: this.$route.query.share,
            };
            this.getGroupShareInfoForSearch();
          }
          break;

        default:
          break;
      }
    } else {
      this.jumpToGroupdrive("groupdisk-file");
      //使用之前选择的drive和tab状态
      this.switchTab(this.tabs[this.searchTab[this.tab]]);
    }
  },
  computed: {
    right__link () {
      return this.$store.getters.right__link
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    isList() {
      return this.$store.state.drive.isList;
    },
    group() {
      return this.$store.state.group.groupInfo;
    },
    share() {
      return this.$store.state.drive.share;
    },
    noClick() {
      return this.level.length ? false : true;
    },
    table() {
      let tab = this.tabs.find((tab) => tab.href === this.tab);
      return tab.table;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    datas() {
      return this.$store.state.drive.datas;
    },
    listQuery() {
      return this.$store.state.drive.listQuery;
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 权限-创建群文件夹
    hasCreateFolderPermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.level.length) {
        // 进入一级文件夹内，根据资源权限判断
        const number = this.level[0].number;
        let resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          let permissions = getRolePermissions(resource.role_type);
          return permissions.indexOf("createFolder") > -1;
        }
        return false;
      } else {
        // 对于一级文件夹，当有[允许角色成员在根目录创建文件夹并设置共享]权限时返回true
        return (
          this.permissions.public_operations.indexOf(
            "allowCreateFolderAndSetPermission"
          ) > -1
        );
      }
    },
    // 权限-资源标签-预览
    hasPreviewResourceTagPermission() {
      return (
        this.permissions.public_operations == "ALL" ||
        this.permissions.public_operations.indexOf("previewResourceTag") > -1 ||
        true
      );
    },
    // 权限-上传文件
    hasUploadFilePermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.level.length) {
        // 进入一级文件夹内，根据资源权限判断
        const number = this.level[0].number;
        let resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          let permissions = getRolePermissions(resource.role_type);
          return permissions.indexOf("uploadFiles") > -1;
        }
        return false;
      }
      return false;
    },
    /**
     * 权限-创建发布
     * 条件：
     * ①群主，则显示
     * ②其他成员，如果该用户有发布权限的文件夹，则显示
     */
    hasCreatePublishSharePermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      let resource = this.permissions.resource_operations.find((item) => {
        return item.role_type == 1 || item.role_type == 6;
      });
      return resource;
    },
    /**
     * 权限-编辑发布
     * 条件：
     * ①群主，则显示
     * ②其他成员，有发布权限，且仅能编辑自己的发布
     */
    hasEditPublishPermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.level[0].link_creater_number == this.user.user_number) {
        return true;
      }
      return false;
    },
    // 是否显示已发布tab
    showPublish() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      let resource = this.permissions.resource_operations.find((item) => {
        return item.role_type == 1 || item.role_type == 6;
      });
      return resource;
    },
  },
  watch: {
    tab() {
      this.level = [];
    },
    $route(to) {
      if (to.query.type) {
        switch (to.query.type) {
          case "file":
            this.jumpToGroupdrive("groupdisk-file");
            if (to.query.number) {
              this.file = {
                number: to.query.number ? to.query.number : 0,
              };
              this.getGroupFileInfoForSearch();
            }
            break;
          case "share":
            this.jumpToGroupdrive("groupdisk-share");
            if (to.query.share) {
              this.file = {
                share_number: to.query.share,
              };
              this.getGroupShareInfoForSearch();
            }
            break;

          default:
            break;
        }
      }
    },
  },
  methods: {
    toggleSearch(searchType) {
      this.searchType = searchType;
    },
    handleSearchGroupFileFilter() {
      $("#search-group-file-filter").modal("show");
    },
    // 修改发布的资源
    handleEditSend(action) {
      linkInfo({
        link_number: this.share.link_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.getLinkResourceList("up");
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 刷新发布列表（当列表显示为发布列表而不是发布资源列表的时候刷新）
    refresh() {
      if (!this.level.length) {
        this.getInfo();
      }
    },
    // 刷新当前的发布资源列表
    refreshResource() {
      this.getLinkResourceList(this.level[0]);
    },
    // 创建发布
    handleCreateSend(action = null) {
      $("#" + action).modal("show");
    },
    jumpToGroupdrive(tab) {
      this.$store.commit("SWITCH_DRIVE", {
        drive: "groupdisk",
        group_number: this.group_number,
        tab: tab,
      });
    },
    /**
     * 跳转到分享@我的固定子分享
     */
    getGroupShareInfoForSearch() {
      this.level = [];
      this.isShowUpload = false;
      this.isShowList = true;
      this.isShowTag = false;
      shareTargetInfo({
        share_number: this.file.share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.getShareResourceList(res.entity);
          } else {
            this.$message({
              type: "warning",
              message: `${res.message} 正在跳转到分享到群列表...`,
            });
            setTimeout(() => {
              this.switchTab(this.tabs[1]);
            }, 1000);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    /**
     * 跳转到群文件的固定子目录
     */
    getGroupFileInfoForSearch() {
      this.level = [];
      this.isShowUpload = true;
      this.isShowList = true;
      this.isShowTag = true;
      this.$store.commit("MODIFY_LIST_QUERY", {
        number: this.file.number,
        disk_type: "cloud",
        is_rec: false,
        offset: null,
        limit: null,
      });
      this.getBread(this.file.number);
      this.getInfo();
    },
    getBread(number) {
      if (number == "0") {
        return false;
      }
      fileOrFolderInfo({
        type: "folder",
        number: number,
        is_path: true,
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.parent_path_number.length > 1) {
              let parent_path_number = res.entity.parent_path_number
                .slice(1)
                .split("/");
              let parent_path_name = res.entity.parent_path_name
                .slice(1)
                .split("/");
              this.level = parent_path_number.map((item, index) => {
                return {
                  number: item,
                  name: parent_path_name[index],
                };
              });
            }
            this.level.push({
              number: res.entity.number,
              name: res.entity.name,
            });
          }
        })
        .catch();
    },
    /**
     * 点击跳转tab
     * 规则：点击当前所在的tab不用
     **/
    switchTabByClick(tab) {
      if (tab.href != this.tab) {
        this.switchTab(tab);
      }
    },
    switchTab(tab) {
      this.bread = tab.bread;
      this.level = [];
      tab.table = "Table";
      this.$store.commit("SWITCH_TAB", tab.href);
      this.isShowUpload = tab.isShowUpload;
      this.isShowList = tab.isShowList;
      this.isShowTag = tab.isShowTag;
      this.getInfo();
    },
    getInfo() {
      this.$store
        .dispatch("getInfo")
        .then((res) => {
          if (res.status_code === 200) {
            if (!this.isList) {
              if (this.tab === "groupdisk-file") {
                this.$store.dispatch("getImgPath");
              } else {
                this.$store.dispatch("getShareImgPath");
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getInfoByFatherId(data) {
      let res = this.level.find((item) => item.number === data.number);
      let index = this.level.indexOf(res);
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      this.$store.commit("MODIFY_LIST_QUERY", {
        number:
          this.level.length === 0
            ? 0
            : this.level[this.level.length - 1].number,
        // offset: 0,
        // limit: 5
      });
      this.getInfo();
    },
    // 获取发布资源列表
    getLinkResourceList(data) {
      let index;
      if (this.level.length > 1) {
        index = this.level.indexOf(data);
      } else {
        let res = this.level.find((item) => {
          return (
            item.link_number === data.link_number || item.number === data.number
          );
        });
        index = this.level.indexOf(res);
      }
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      let tab = this.tabs.find((item) => item.href === this.tab);
      if (this.level.length === 0) {
        this.$store.commit("setDatas", []);
        tab.table = "Table";
        this.getInfo();
        return false;
      } else {
        this.$store.commit("setDatas", []);
        tab.table = "TableShareResource";
      }
      this.$store
        .dispatch("getLinkResourceList", {
          link_creater_name: data.link_creater_name,
          link_number:
            this.level.length === 0
              ? data.link_number
              : this.level[0].link_number,
          link_resource_number:
            this.level.length < 2
              ? null
              : this.level[this.level.length - 1].number,
          is_rec: "false",
        })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setLoading", false);
            this.$store.commit("GET_RESOURCE_INFO", res.entity);
            if (!res.entity.length) {
              this.$store.commit("setNothing", true);
            } else {
              this.$store.commit("sortByDefault", 3);
              this.$store.commit("sortByHeader");
              if (!this.isList) {
                this.$store.dispatch("getImgPath");
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取分享资源列表
    getShareResourceList(data) {
      let index;
      if (this.level.length > 0) {
        index = this.level.indexOf(data);
      } else {
        let res = this.level.find((item) => {
          return (
            item.share_number === data.share_number ||
            item.number === data.number
          );
        });
        index = this.level.indexOf(res);
      }
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      let tab = this.tabs.find((item) => item.href === this.tab);
      if (this.level.length === 0) {
        this.$store.commit("setDatas", []);
        tab.table = "Table";
        this.getInfo();
        return false;
      } else {
        this.$store.commit("setDatas", []);
        tab.table = "TableShareResource";
      }
      this.$store
        .dispatch("getShareResourceList", {
          share_creater_name: data.share_creater_name,
          share_number:
            this.level.length === 0
              ? data.share_number
              : this.level[0].share_number,
          share_resource_number:
            this.level.length < 2
              ? null
              : this.level[this.level.length - 1].number,
          is_rec: "false",
        })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setLoading", false);
            this.$store.commit("GET_RESOURCE_INFO", res.entity);
            if (!res.entity.length) {
              this.$store.commit("setNothing", true);
            } else {
              this.$store.commit("sortByDefault", 3);
              this.$store.commit("sortByHeader");
              if (!this.isList) {
                this.$store.dispatch("getShareImgPath");
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    filterByTag(tagName) {
      this.listQuery.tag = tagName;
      this.$store.commit();
      this.getInfo();
    },
    getAllInfo() {
      if (
        ["groupdisk-share", "groupdisk-send"].indexOf(
          this.$store.state.drive.tab
        ) > -1
      ) {
        this.$store.commit("setDatas", []);
      }
      let tab = this.tabs.find((item) => item.href === this.tab);
      tab.table = "Table";
      this.level = [];
      this.$store.commit("MODIFY_LIST_QUERY", {
        number: 0,
        offset: 0,
        // limit: 5
      });
      this.getInfo();
    },
    showList(isList) {
      this.$store.commit("setIsList", isList);
      if (!isList) {
        this.$store.dispatch("getImgPath");
      }
    },
    createNewFolder() {
      this.$store.commit("createNewFolder", Object.assign({}, this.temp));
      this.$nextTick(function () {
        this.$store.commit("setFocusState", true);
      });
    },
    updateCreateProcessing(status) {
      this.isCreateProcessing = status;
    },
    saveNewFolder(folderName) {
      this.isCreateProcessing = true;
      this.$store
        .dispatch("newFolders", {
          group_number: this.listQuery.group_number,
          number:
            this.level.length === 0
              ? "0"
              : this.level[this.level.length - 1].number,
          paramslist: [folderName],
          disk_type: "cloud",
        })
        .then((res) => {
          if (res.status_code === 200) {
            this.isCreateProcessing = false;
            this.$nextTick(function () {
              this.$store.commit("setFocusState", false);
            });
            this.$message({
              type: "success",
              message: res.message,
            });
            if (res.entity[0].parent_number == "0") {
              this.$store.commit("addGroupResourcePermission", {
                folder_id: res.entity[0].number,
                role_type: 1,
              });
            }
            this.$store.commit("changeDataOfDatas", {
              number: res.entity[0].number,
              name: res.entity[0].new_name,
              creater_user_real_name: this.$store.state.user.userInfo.name,
              last_update_date: res.entity[0].last_update_date,
              parent_number: res.entity[0].parent_number,
              parent_path_number: res.entity[0].parent_path_number,
            });
          } else {
            this.isCreateProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isCreateProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 1000);
  },
};
</script>

<style scoped>
.no-click {
  color: #ddd;
  cursor: default;
}
.more-rec {
  color: #006adf;
}
.add-resource-btn {
  color: #006adf;
  float: right;
  cursor: pointer;
}
.add-resource-btn i {
  color: #006adf;
}
.notice-p {
  word-break: break-all;
}
</style>